import React, { useCallback, useEffect } from "react";

import { notification } from "antd";

/**
 * <Notification/>
 *
 * @param {ReactNode} message Content text
 * @param {ReactNode} description Content title
 * @param {() => void} open open Notification component
 * @param {() => void} onClose close Notification component
 * @param {string} placement topLeft | topRight | bottomLeft | bottomRight
 * @param {string} notificationKey Unique Key to only update the dedicated notification
 * @returns {JSX.Element}
 * @constructor
 */

export const Notification = ({ message, description, open, onClose, placement, className, notificationKey }) => {
  const [api, contextHolder] = notification.useNotification();

  const destroyNotifications = useCallback(() => {
    api.destroy(notificationKey);
  }, [api, notificationKey]);

  const openNotification = useCallback(() => {
    api.open({
      id: notificationKey,
      key: notificationKey,
      message: message,
      description: description,
      duration: 0,
      onClose: onClose,
      placement: placement,
      className: className,
      maxCount: 1,
    });
  }, [api, notificationKey, onClose, placement, className, description, message]);

  useEffect(() => {
    if (open) {
      destroyNotifications();
      openNotification();
    }
  }, [open, notificationKey, openNotification, destroyNotifications]);

  return <>{open ? contextHolder : false}</>;
};

export default Notification;
